import * as React from 'react';
import styled from 'styled-components';
import { ERROR_COLOUR } from 'govuk-colours';
import { SPACING } from '@govuk-react/constants';
import LabelText from '@govuk-react/label-text';
import ErrorText from '@govuk-react/error-text';
import HintText from '@govuk-react/hint-text';
import { spacing } from '@govuk-react/lib';
import BaseInput from '@govuk-react/input';
import Label from '@govuk-react/label';
import multiInputInput from 'multi-input-input';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var StyledLabel = styled(Label).withConfig({
  displayName: "input__StyledLabel",
  componentId: "sc-una33r-0"
})({
  marginRight: '20px',
  marginBottom: 0
}, function (_ref) {
  var year = _ref.year;
  return {
    width: year ? '70px' : '50px'
  };
});
var StyledList = styled('div').withConfig({
  displayName: "input__StyledList",
  componentId: "sc-una33r-1"
})({
  display: 'flex'
});

var Input = /*#__PURE__*/function (_React$Component) {
  _inherits(Input, _React$Component);

  var _super = _createSuper(Input);

  function Input() {
    var _this;

    _classCallCheck(this, Input);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "inputs", {});

    return _this;
  }

  _createClass(Input, [{
    key: "renderInput",
    value: function renderInput(label, name, key, defaultValue, input, error) {
      var _this2 = this;

      var _this$props = this.props,
          value = _this$props.value,
          _onChange = _this$props.onChange,
          _onBlur = _this$props.onBlur,
          _onFocus = _this$props.onFocus,
          refs = _this$props.refs;
      return /*#__PURE__*/React.createElement(StyledLabel, {
        year: key === 'year'
      }, /*#__PURE__*/React.createElement(LabelText, null, label), /*#__PURE__*/React.createElement(BaseInput, _extends({
        name: name,
        error: !!error,
        defaultValue: defaultValue,
        value: value ? value[key] : undefined,
        onChange: function onChange(e) {
          return _onChange(e, key);
        },
        onBlur: function onBlur(e) {
          return _onBlur(e, key);
        },
        onFocus: function onFocus(e) {
          return _onFocus(e, key);
        },
        ref: function ref(inputElement) {
          _this2.inputs[key] = inputElement;
          refs(_this2.inputs);
        }
      }, input)));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          labels = _this$props2.labels,
          names = _this$props2.names,
          defaultValues = _this$props2.defaultValues,
          inputs = _this$props2.inputs,
          error = _this$props2.error;
      return /*#__PURE__*/React.createElement(StyledList, null, this.renderInput(labels.day, names.day, 'day', defaultValues.day, inputs.day, error), this.renderInput(labels.month, names.month, 'month', defaultValues.month, inputs.month, error), this.renderInput(labels.year, names.year, 'year', defaultValues.year, inputs.year, error));
    }
  }]);

  return Input;
}(React.Component);

_defineProperty(Input, "defaultProps", {
  value: undefined,
  names: {
    day: 'DateFieldDay',
    month: 'DateFieldMonth',
    year: 'DateFieldYear'
  },
  defaultValues: {
    day: undefined,
    month: undefined,
    year: undefined
  },
  inputs: {
    day: undefined,
    month: undefined,
    year: undefined
  },
  labels: {
    day: 'Day',
    month: 'Month',
    year: 'Year'
  },
  error: false,
  refs: undefined,
  onChange: undefined,
  onBlur: undefined,
  onFocus: undefined
});

// This component is dependent on multiInputInput HOC so we always export with HOC
var Input$1 = multiInputInput(Input);

var _excluded = ["children", "errorText", "hintText", "inputNames", "defaultValues", "inputs", "input"];
var StyledContainer = styled('div').withConfig({
  displayName: "src__StyledContainer",
  componentId: "sc-1l2t4xv-0"
})({
  display: 'flex',
  flexDirection: 'column'
}, function (_ref) {
  var errorText = _ref.errorText;
  return errorText ? {
    borderLeft: "4px solid ".concat(ERROR_COLOUR),
    marginRight: SPACING.SCALE_3,
    paddingLeft: SPACING.SCALE_2
  } : undefined;
}, spacing.withWhiteSpace({
  marginBottom: 6
}));
/**
 * Use the date input component to help users enter a memorable date or one they can easily look up.
 *
 * - https://govuk-react.github.io/govuk-react/?path=/docs/date-field
 * - https://design-system.service.gov.uk/components/date-input/
 */

var DateField = function DateField(_ref2) {
  var children = _ref2.children,
      errorText = _ref2.errorText,
      hintText = _ref2.hintText,
      inputNames = _ref2.inputNames,
      defaultValues = _ref2.defaultValues,
      inputs = _ref2.inputs,
      input = _ref2.input,
      props = _objectWithoutProperties(_ref2, _excluded);

  return /*#__PURE__*/React.createElement(StyledContainer, _extends({}, props, {
    errorText: errorText
  }), /*#__PURE__*/React.createElement(LabelText, null, children), hintText && /*#__PURE__*/React.createElement(HintText, null, hintText), errorText && /*#__PURE__*/React.createElement(ErrorText, null, errorText), /*#__PURE__*/React.createElement(Input$1, _extends({
    names: inputNames,
    defaultValues: defaultValues,
    error: !!errorText,
    inputs: inputs
  }, input)));
};
DateField.displayName = 'DateField';
DateField.Container = StyledContainer;
DateField.Input = Input$1;
DateField.defaultProps = {
  hintText: undefined,
  errorText: undefined,
  inputNames: {
    day: undefined,
    month: undefined,
    year: undefined
  },
  defaultValues: {
    day: undefined,
    month: undefined,
    year: undefined
  },
  inputs: {
    day: undefined,
    month: undefined,
    year: undefined
  },
  input: undefined
};

export { DateField, DateField as default };
